import React from 'react'

import DesktopIndexPagination from '../../components/DesktopIndexPagination'

export default function RefundIndexDesktopPagination({
  pagination,
  onPageChange,
  onRowsPerPageChange
}) {
  return (
    <DesktopIndexPagination
      ariaLabel="Paginacion de devoluciones"
      pagination={pagination}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  )
}
